import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '../../environments/environment';
import { StorageService } from '../services';

export const ApiInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);

  const authToken = storageService.getToken();
  const apiReq = req.clone({
    url: `${environment.apiUrl}${req.url}`,
    ...(authToken
      ? {
          setHeaders: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      : {}),
  });

  return next(apiReq);
};
